/**
 * @description 发行平台-发行详情-发售详情卡片
*/

import React from "react";
import { round } from "@/utils/publicFun"
import "./index.scss";
import dayjs from "dayjs"
import logo from '@/assets/img/lvdi.png'

const DetailCard = (props) => {

	const {dataSource={}} = props

	return (
		<div className="detailCard">
			<div className="content_title">发售详情</div>
			<div className="content_spacebt">
				<span>发行价格</span>
				<span>¥{round(dataSource.price, 2)}</span>
			</div>
			<p className="content_radio">{dataSource?.hasIntegralDeduction === 1 ? '可使用积分抵扣' : '不可使用积分抵扣'}</p>
			<div className="content_spacebt" style={{ display: 'flex', alignItems: 'center'}}>
				<span>发行时间</span>
				<span className="time-text">
					{dataSource.saleStartTime ? dayjs(dataSource.saleStartTime).format('YYYY-MM-DD HH:mm:ss') : ''}
					-{dataSource.saleEndTime ? dayjs(dataSource.saleEndTime).format('YYYY-MM-DD HH:mm:ss') : ''}
				</span>
			</div>
			<div className="content_spacebt">
				<span>发行数量</span>
				<span>{dataSource?.publishQuantity || 0}份</span>
			</div>
			{
				dataSource?.rarity &&
				<div className="content_spacebt">
					<span>稀有度</span>
					<span style={{color: '#CEBF7E'}}>{dataSource?.rarity}</span>
				</div>
			}
			<div className="content_spacebt">
				<span>发行方</span>
				<div className="content_home">
					<img className="issuer_logo" src={dataSource?.issuerLogo || logo} alt="logo" />
					{dataSource?.issuerName || '绿地集团'}
				</div>
			</div>
		</div>
	)
}

export default DetailCard;